import applicationReducer from './applicationSlice';
import * as applicationActions from './actions';
import * as applicationSelector from './selector';

export {
  applicationActions,
  applicationSelector
}

export default applicationReducer